import React from 'react';
import { translate } from 'react-i18next';

class TimeSheetItem extends React.Component {
  _renderTime(label, time) {
    if (time != null) {
      return (
        <li className="highlighted">
          {label}
          {' '}
          {moment(time)
            .tz(Utils.getCoreUser().inferred_time_zone)
            .format('h:mm A')}
        </li>
      );
    }
  }

  _getBreaks(breakPunchIds) {
    const breakItmes = breakPunchIds.map(id => (
      <li>
        {moment(TimeSheetStore.getBreakPunchById(id).starts_at)
          .tz(Utils.getCoreUser().inferred_time_zone)
          .format('h:mm A')}
        -
        {moment(TimeSheetStore.getBreakPunchById(id).ends_at)
          .tz(Utils.getCoreUser().inferred_time_zone)
          .format('h:mm A')}
      </li>
    ));

    return breakItmes;
  }

  render() {
    const start = moment(
        this.props.data.shift_starts_at
          ? this.props.data.shift_starts_at
          : this.props.data.punched_in_at,
      )
      .tz(Utils.getCoreUser().inferred_time_zone);
    return (
      <div className="timesheet-item">
        <div className="timesheet-item-title">
          {['en', 'en_ca'].includes(Utils.getLocale()) &&
            start.format('dddd, MMM, D')
          } 
          {'fr' == Utils.getLocale() &&
            start.format('dddd D MMM').replace(/\./g, '')
          }
          {'es' == Utils.getLocale() &&
            start.format('dddd, D MMM').replace(/\./g, '')
          }
        </div>
        <div className="timesheet-item-columns">
          <div className="timesheet-column timesheet-column-hours">
            <p>
              {`${this.props.t('TimeSheetItem.total_hours_worked')}: `}
              {Utils.getLocale() === 'fr' 
                ? (Number(this.props.data.work_duration) / 3600).toLocaleString('fr', { minimumFractionDigits: 2 })
                : (Number(this.props.data.work_duration) / 3600).toFixed(2)
              }
            </p>
            <ul>
              <li>{this.props.data.shift_name}</li>
              <li>{this.props.currentLocation}</li>
              <li>{this.props.data.department}</li>
              <li>{this.props.data.job_site}</li>
              <li>{this.props.data.job_site_address}</li>
              <li>{this.props.data.position}</li>
            </ul>
          </div>
          <div className="timesheet-column timesheet-column-details">
            <p>{this.props.t('TimeSheetItem.details')}</p>
            <ul>
              {this.props.data.break_duration > 0 && (
                <li>
                  {this.props.t('TimeSheetItem.included_breaks')}:
                  {Number(this.props.data.break_duration) / 60}
                  {' '}
                  {this.props.t('TimeSheetItem.min')}
                </li>
              )}
            </ul>
          </div>
          <div className="timesheet-column timesheet-column-scheduled">
            <p>{this.props.t('TimeSheetItem.scheduled')}</p>
            <ul>
              {this._renderTime(`${this.props.t('TimeSheetItem.in')}: `, this.props.data.shift_starts_at)}
              {this._renderTime(`${this.props.t('TimeSheetItem.out')}: `, this.props.data.shift_ends_at)}
            </ul>
          </div>
          <div className="timesheet-column timesheet-column-clock">
            <p>{this.props.t('TimeSheetItem.clock_in_out')}</p>
            <ul>
              <li className="highlighted">
                {`${this.props.t('TimeSheetItem.in')}: `}
                {moment(this.props.data.punched_in_at)
                  .tz(Utils.getCoreUser().inferred_time_zone)
                  .format('h:mm A')}
              </li>
              <li className="highlighted">
                {`${this.props.t('TimeSheetItem.out')}: `}
                {moment(this.props.data.punched_out_at)
                  .tz(Utils.getCoreUser().inferred_time_zone)
                  .format('h:mm A')}
              </li>
            </ul>
          </div>
          {this.props.displayBreakPunches && (
            <div className="timesheet-column timesheet-column-breaks">
              <p>{this.props.t('TimeSheetItem.breaks')}</p>
              <ul>{this._getBreaks(this.props.data.break_punch_ids)}</ul>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default translate()(TimeSheetItem);
